// relative
import { daluxIntegrationApiSlice } from '../apiSlice';

type DaluxApiKeyRecord = {
  hasApiKey: string | boolean | null;
  expiresAt?: string | null;
};

type SaveDaluxApiKeyRequest = {
  accountId: string | number;
  apiKey: string;
  expiresAt?: string | null;
};

export const daluxApiSlice = daluxIntegrationApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDaluxApiKey: builder.query<DaluxApiKeyRecord, string | number>({
      query: (accountId) => `/${accountId}/api-key`,
      providesTags: ['DaluxApiKey'],
    }),
    saveDaluxApiKey: builder.mutation<void, SaveDaluxApiKeyRequest>({
      query: ({ accountId, apiKey, expiresAt }) => ({
        url: `/${accountId}/api-key`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: { apiKey, expiresAt },
      }),
      invalidatesTags: ['DaluxApiKey'],
    }),
  }),
});

export const { useGetDaluxApiKeyQuery, useSaveDaluxApiKeyMutation } =
  daluxApiSlice;
